import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VDataTable, {
        key: _vm.key_table,
        staticClass: "table-inca",
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-footer": true,
          page: _vm.pagination.current,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination, "current", $event)
          },
          pagination: function ($event) {
            _vm.pagination.total = $event.itemsLength
          },
        },
      }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }